export const SET_LOADING = 'SET_LOADING';

export const setLoading = (payload) => ({
  type: SET_LOADING,
  payload
})
